import { Component, h, Listen, State, Host, Element, Prop } from '@stencil/core';
import { JackeryCommentOverview as _JackeryCommentOverview } from '../jackery-comment-overview/jackery-comment-overview';
import { getClassPrefix } from '../../utils/utils';
import classNames from 'classnames';
import { JackeryCommentItem as _JackeryCommentItem } from '../jackery-comment-item/jackery-comment-item';
import { JackerySkeleton as _JackerySkeleton } from '../jackery-skeleton/jackery-skeleton';
import {commentRating, commentList, commentAdd} from "../../utils/api/comment"
import {CommentOverview, CommentItem} from "../../common/interface"
import { getLocaleComponentStrings } from "../../utils/locale";
import { JackeryButton as _JackeryButton } from '../jackery-button/jackery-button';

@Component({
  tag: 'jackery-comment',
  styleUrl: 'jackery-comment.css'
})
export class JackeryComment {
  strings: any; // 多语言
  @Element() hostElement: HTMLElement;

  /**
   * 评论关联id
   */
  @Prop() cid: string;

  /**
   * 评论类型 1：商品评论
   */
  @Prop() ctype: string;

  /**
   * 店铺id
   */
  @Prop() shopid: string;

  /**
   * 评论图片限制数量
   */
  @Prop() imgLimit: string;

  @State() isLoading: boolean = true; // 评论列表加载状态
  @State() rateLoading: boolean = true; // 评分加载状态
  @State() currentPage: number = 1; // 当前页码
  @State() limit: number = 5; // 每页评论数
  @State() isLoadingMore: boolean = false; // 加载更多状态
  @State() isEnd: boolean = false; // 评论是否全部加载完
  @State() commentOverview: CommentOverview; // 评论评分信息
  @State() commentList: CommentItem[] = []; // 评论列表
  @State() isSubmitting: boolean = false; // 正在提交中
  @State() sortType: number | null; // 评论排序分类
  @State() rating: number | null; // 评论筛选分数
  @Listen('customEvent', { target: 'window' })
  customEvent(event: CustomEvent) { // 提交评论触发
    this.isSubmitting = true
    const formData = new FormData();
    for (let key in event.detail) {
      if(key === 'image') {
        for (let i = 0; i < event.detail[key].length; i++) {
          formData.append('image', event.detail[key][i]);
        }
      } else {
        formData.append(key, event.detail[key]);
      }
    }
    formData.append('dataId', this.cid);
    formData.append('type', this.ctype || '1');
    formData.append('shopShopifyId', this.shopid || '55005249633');
    this.commentList = []
    commentAdd(formData).then(_res => {
      this.commentOverviewRef?.handleCloseForm();
      this.isSubmitting = false
      this.currentPage = 1
      this.getCommentList()
      this.getRatingOverview()
    })
  }

  @Listen('ratingFilterEvent', { target: 'window' })
  ratingFilterEvent(event: CustomEvent) {
    const rating = parseInt(event.detail) || null
    this.rating = rating
    this.commentList = []
    this.currentPage = 1
    this.isEnd = false
    this.getCommentList({rating})
  }

  @Listen('sortFilterEvent', { target: 'window' })
  sortFilterEvent(event: CustomEvent) {
    const sortType = parseInt(event.detail) || null
    this.sortType = sortType
    this.commentList = []
    this.currentPage = 1
    this.isEnd = false
    this.getCommentList({sortType})
  } 

  commentOverviewRef?: any;

  async componentWillLoad() {
    this.strings = await getLocaleComponentStrings(this.hostElement);
    this.getRatingOverview()
    this.getCommentList()
  }

  handleSetHeaderMsg() { // 设置评论header（锚点）
    if(!document.querySelector("jackery-commetn-header")) return
    document.querySelector("jackery-commetn-header").setAttribute("rating", this.commentOverview.rating)
    document.querySelector("jackery-commetn-header").setAttribute("count", this.commentOverview.count.toString())
    document.querySelector("jackery-commetn-header").setAttribute("list", JSON.stringify(this.commentOverview.list))
  }

  getRatingOverview() { // 获取评论评分信息
    this.rateLoading = true;
    commentRating({
      type: this.ctype || 1,
      dataId: this.cid,
      shopShopifyId: this.shopid || '55005249633'
    }).then(res => {
      const __res = {...res as CommentOverview}
      __res.list.map(item => {
        if(item.num === 0) { item.percent = 0; return }
        item.percent = item.num / __res.count
      })
      __res.list.sort((a, b) => parseInt(b.rating) - parseInt(a.rating))
      this.commentOverview = {...__res}
      this.rateLoading = false;
      console.log(this.commentOverview)

      this.handleSetHeaderMsg()
    })
  }
  
  handleLoadMore() {
    if(this.isEnd) return
    this.currentPage++
    this.isLoadingMore = true
    this.getCommentList({}, true)
  }

  getCommentList(params = {}, loading = false) { // 获取评论列表
    !loading && (this.isLoading = true)
    const default_params = {
      page: this.currentPage,
      limit: this.limit,
      // page: 1,
      // limit: this.limit * this.currentPage,
      rating: this.rating,
      sortType: this.sortType || 0,
      type: this.ctype,
      dataId: this.cid,
      shopShopifyId: this.shopid || '55005249633'
    }
    commentList(Object.assign(default_params, params)).then(res => {
      this.isLoading = false;
      const list = (res as any).data
      if(list.length === 0 ) {
        this.isEnd = true
      } else {
        list.forEach(ele => {
          !ele.imageUrls && (ele.imageUrls = []) // img为空设置初始值
        });
        this.commentList = [...this.commentList, ...list]
        // this.commentList = [...list]
      }
      if(loading) this.isLoadingMore = false
    })
  }

  private renMain() {
    const classPrefix: string = getClassPrefix('comment');
    const classes: string = classNames(classPrefix);

    return (<div class={classes}>
      { this.rateLoading ? <jackery-skeleton type="overview" /> : <jackery-comment-overview imgLimit={parseInt(this.imgLimit) || 5} ref={el => (this.commentOverviewRef = el)} isSubmitting={this.isSubmitting} commentOverview={this.commentOverview}></jackery-comment-overview>}
      
      { this.isLoading ? <jackery-skeleton type="reviewitem" /> : <div>
          {this.commentList.map(item => <jackery-comment-item commentItem={item} />)}
          <div
            class={{
              'loading_more_wrapper': true,
              'loading_more_wrapper__loading': this.isLoadingMore
            }}
          >
            {!this.isLoadingMore ? 
            <jackery-button 
            type="primary" 
            shape='square'
            disabled={this.isEnd ? 'disabled' : undefined}
            onClick={() => {this.handleLoadMore()}}>{this.isEnd ? this.strings.no_more : this.strings.load_more}</jackery-button>
            
            : <div><jackery-skeleton type="reviewitem" /><jackery-skeleton type="reviewitem" /><jackery-skeleton type="reviewitem" /></div>
            }
          </div>
      </div>}
    </div>)
  }

  render() {
    return (
      <Host>
        {this.renMain()}
      </Host>
    );
  }
}